<template>
  <div :class="{'cursor-pointer' : isClickable}">
    <!--div v-if="!travelBuddyMeeting" class="card flex flex-row items-center h-40 lg:h-44 p-4">
      <div class="w-28 mr-4">
        <div class="flex justify-center">
          <img class="" :src= "getProfilePic" alt="image">
        </div>
      </div>
      <div class="flex w-2/3">
        <div class="text-xl font-normal">{{$t('TravelBuddy.noTravelBuddyText')}}</div>
      </div>
    </div-->
    <div v-if="travelBuddyMeeting" class="flex flex-col sm:flex-row justify-between sm:items-center items-start cursor-pointer
      card min-h-40 lg:min-h-44 gap-3 w-full"
      @click.prevent="openCard">
      <div class="flex flex-row items-center gap-x-2">
        <div class="flex flex-row shrink-0">
            <div class="flex justify-center w-14 h-14 sm:w-20 sm:h-20">
                <img :src="getProfilePic" alt="" class="rounded-full h-14 w-14 sm:h-20 sm:w-20 object-cover">
            </div>
        </div>
        <div class="flex flex-col">
          <span class="text-base sm:text-xl lg:text-2xl">{{ $t('TravelBuddy.travelBuddy', {text: featureName}) }}</span>
          <span class="text-sm sm:text-lg lg:text-xl truncate">{{ travelBuddyMeeting.teammateFull }}</span>
        </div>
      </div>
      <div v-if="showFeedbackButton" class="flex w-full sm:w-fit min-w-0">
        <Button type="submit" @click.prevent="markMeeting('completed')"
          class="btn-primary-accent px-3 py-1.5 sm:px-2 sm:py-1 text-sm sm:text-base mt-1 w-full sm:w-fit" unstyled>
          {{ $t('TravelBuddyFeedbackOverlayComponent.provideFeedback') }}
        </Button>
      </div>
      <div v-else class="flex w-full sm:w-fit min-w-0">
        <Button type="submit" @click.prevent="openCard"
            class="btn-primary-accent px-3 py-1.5 sm:px-2 sm:py-1 text-sm sm:text-base mt-1 w-full sm:w-fit" unstyled>
            {{ getProgressBarText }}
        </Button>
      </div>
    </div>
  </div>
  <TravelBuddyExpandedCardComponent :visible="showCard"
      @update:visible="showCard = $event"></TravelBuddyExpandedCardComponent>
  <TravelBuddyFeedbackOverlayComponent v-if="showDialog" :visible="showDialog"
      @update:visible="showDialog = $event"></TravelBuddyFeedbackOverlayComponent>
</template>
<script>
import defaultProfileImage from '@/assets/defaultProfileImage.js';
import { Button } from 'primevue';
import TravelBuddyExpandedCardComponent from './TravelBuddyExpandedCardComponent.vue';
import TravelBuddyFeedbackOverlayComponent from '../Shared/FrontendOverlays/TravelBuddyFeedbackOverlayComponent.vue';
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  name: 'TravelBuddyCardComponent',
  components: { Button, TravelBuddyExpandedCardComponent, TravelBuddyFeedbackOverlayComponent },
  data() {
    return {
      refreshValue: this.$store.state.content.refreshValue,
      showDialog: false,
      showCard: false,
    };
  },
  methods: {
    async markMeeting(status) {
      try {
        this.showDialog = true;
        this.$store.commit('setTravelBuddyMeetingStatus', status);
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error!',
          detail: '',
          life: 3000,
        });
      }
    },
    openCard() {
      if (this.isClickable) {
        this.showCard = true;
      }
    },
  },
  computed: {
    featureName() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'travelBuddyHistory',
        this.$t('FallbackTexts.travelBuddyHistory'),
        this.$i18n?.locale,
      );
    },
    isClickable() {
      return this.$store.getters.getTravelBuddyMeetingStatus === 'created';
    },
    meetingStatusSelected() {
      return this.$store.getters.getTravelBuddyMeetingStatus;
    },
    travelBuddyMeeting() {
      const travelBuddyMeetingInfo = this.$store.getters.getTravelBuddyMeetingInfo;
      if (travelBuddyMeetingInfo.meetingThisWeek) {
        return travelBuddyMeetingInfo;
      }
      return false;
    },
    getRefreshValue() {
      return this.$store.getters.getRefreshValue;
    },
    getProfilePic() {
      // eslint-disable-next-line global-require
      if (this.travelBuddyMeeting?.teammatePhoto) {
        return `${this.travelBuddyMeeting?.teammatePhoto}?_${this.getRefreshValue}`;
      }

      return defaultProfileImage;
    },
    getProgressBarText() {
      const status = this.meetingStatusSelected;
      if(status.toLowerCase() === 'completed') {
        return this.$t('TravelBuddyFeedbackOverlayComponent.provideFeedback');
      }
      if(status.toLowerCase() === 'skipped') {
        return this.$t('TravelBuddyHistory.skippedButtonText');
      }
      return this.$t('TravelBuddyHistory.createdButtonText');
    },
    progress() {
      if (this.meetingStatusSelected === 'completed') {
        return 'background: var(--color-orange)';
      }
      return 'background: var(--color-light-grey)';
    },
    showFeedbackButton() {
      return this.$store.getters.getTravelBuddyFeedbackText === '' && this.$store.getters.getTravelBuddyMeetingStatus === 'completed';
    },
  },
};
</script>
<style scoped>
.other-actions span::after {
  content: '';
  width: 0;
  height: 1px;
  display: block;
  background: var(--color-dark);
  transition: 300ms ease-out;
}

.other-actions span:nth-child(1)::after{
  background-color: var(--color-orange);
}

.other-actions span:hover::after {
  width: 100%;
}
</style>
